import { i18n } from '@/i18n';
import { notifyError } from '@/shared/notify';

const MEDIA_ACCESS_NOTIFICATION_ID = 'media-access-error';
const DEVICE_LIST_NOTIFICATION_ID = 'device-list-error';

export function notifyMediaAccessError(error: unknown) {
    notifyError(i18n.t('prejoin:errors.devices'), error, MEDIA_ACCESS_NOTIFICATION_ID);
}

export function notifyDeviceListError(error: Error) {
    if (error.name === 'NotAllowedError') notifyMediaAccessError(error);
    else notifyError(i18n.t('prejoin:errors.deviceList'), error, DEVICE_LIST_NOTIFICATION_ID);
}

export function notifyDeviceStartError(source: 'camera' | 'microphone', error: unknown) {
    if (error instanceof Error && error.name === 'NotAllowedError') notifyMediaAccessError(error);
    else notifyError(i18n.t(`conference:controls.${source}.error`), error);
}
